import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "@p0security/shared/install/types";
import { mapValues } from "lodash-es";

import { DatadogSites } from "./sites.ts";

const allSecretManagers = newSecretManagerElement({
  owner: "Datadog organization",
  connector: "Datadog",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export const DatadogAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to Datadog",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      site: Element({
        label: "Datadog site",
        description:
          "The Datadog site that hosts this organization, as shown in its URL (e.g. us5.datadoghq.com)",
        type: "select",
        default: "us1",
        step: "new",
        options: mapValues(DatadogSites, ({ label, domain }) =>
          Option({ label: `${label} (${domain})`, maturity: "ga", schema: {} })
        ),
      }),
      secretManager,
      serviceAccountId: Element({
        label: "Service account ID",
        description:
          "ID of the Datadog service account that owns the access tokens P0 creates. Its role limits which scopes can be requested.",
        type: "string",
      }),
    },
  }),
});
